import { render, staticRenderFns } from "./ServerStatusPage.vue?vue&type=template&id=0e47003b&scoped=true&"
import script from "./ServerStatusPage.vue?vue&type=script&lang=js&"
export * from "./ServerStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47003b",
  null
  
)

export default component.exports